import { isSsr } from './DetectSSR';

export const isMobile = () => (!isSsr() ? /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  navigator.userAgent,
) : false);
export const isDesktop = () => !isMobile();
